module.exports = __webpack_public_path__ + "img/151.8c718825.jpg";